import { CSVLink } from 'react-csv';
import { Box, Button } from '@mui/material';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import { CsvHeaderModel } from '../models/CsvHeader';
import { LoadingButton } from '@mui/lab';

interface Props {
    data: any,
    headers: CsvHeaderModel[],
    filename: string,
    title: string,
    buttonRef: any,
    onClick: VoidFunction,
    loading:boolean
}

const ButtonExportCsv = ({ data, headers, filename, title, buttonRef, onClick,loading }: Props) => {
    return (
        <div>
            <Box sx={{ display: 'none' }}>
                <CSVLink ref={buttonRef} data={data} headers={headers} filename={filename} style={{ textDecoration: 'none' }}>

                </CSVLink>
            </Box>

            <LoadingButton loading={loading} onClick={onClick} variant="contained" sx={{ textTransform: 'none' }}><DownloadForOfflineIcon />&nbsp; {title}</LoadingButton>
        </div>
    );
};

export default ButtonExportCsv;
